export default function getSimpleDateString(str) {
    try {
        if (str === undefined || str === 'undefined' || str === null || str === 'null')
            return '';
        return String((new Date(str).toISOString()).substring(0, 10));
    }
    catch (_a) {
        console.error('Malformed date was passed to getSimpleDateString');
        debugger;
        return '';
    }
}
